export default {
  app: {
    orgCode: "ჯგუფის/ბრენდის ნომერი",
    orgCodePlaceholder: "შეიყვანოთ ჯგუფის/ბრენდის ნომერი",
    username: "ანგარიში",
    usernamePlaceholder: "გთხოვთ შეიყვანოთ ანგარიში",
    password: "პაროლი",
    passwordPlaceholder: "გთხოვთ შეიყვანოთ პაროლი",
    captcha: "დამადასტურებელი კოდი",
    captchaPlaceholder: "გთხოვთ შეიყვანოთ საკოდი",
    captchaExpired: "გთხოვთ, განაახლოთ დადასტურების კოდი.",
    login: "შესვლა",
    remember: "დამიმახსოვრე",
    switchPC: "ფონზე გადართვა",
    mobileVersion: "მობილური BI",
    desktopVersion: "მოვაჭრის ბექენდი",
    setupPassword: "პაროლის დაყენება",
    newPassword: "ახალი პაროლი",
    newPasswordPlaceholder: "შეიყვანოთ ახალი პაროლი",
    retypePassword: "ხელახლა შეიყვანეთ ახალი პაროლი",
    retypePasswordPlaceholder: "გთხოვთ, ხელახლა შეიყვანოთ თქვენი ახალი პაროლი",
    setupPasswordRule: "პაროლი უნდა იყოს 6-32 სიმბოლოს სიგრძის და უნდა შეიცავდეს ციფრების, ასოების და სიმბოლოების ორ ან მეტ კომბინაციას.",
    setupPasswordRuleRefer: "პაროლი უნდა იყოს 6-32 სიმბოლოს სიგრძის და უნდა შეიცავდეს ციფრების, ასოების და სიმბოლოების ორ ან მეტ კომბინაციას. გთხოვთ, ხელახლა შეიყვანოთ.",
    setupPasswordOk: "რა თქმა უნდა",
    setupPasswordDiffer: "ორჯერ შეყვანილი პაროლები არ ემთხვევა. გთხოვთ, ხელახლა შეიყვანოთ პაროლი.",
    err_def: "შესვლა ვერ მოხერხდა, გთხოვთ განაახლოთ გვერდი და თავიდან სცადოთ.",
    err_2000: "ვერიფიკაციის კოდი არასწორად იყო შეყვანილი.",
    err_2010: "შესვლის ინფორმაცია არასწორად იყო შეყვანილი.",
    err_4001: "ამ ანგარიშს არ აქვს ავტორიზებული არცერთი ფუნქცია.",
    err_4011: "მაღაზია დეაქტივირებულია, შესვლა შეუძლებელია. ",
    err_4012: "ფრენჩაიზის მფლობელი დეაქტივირებულია და, შესვლა შეუძლებელია.",
    err_4013: "ბრენდი გამორთულია, შესვლა შეუძლებელია.",
    err_4014: "ჯგუფი გამორთულია და, შესვლა შეუძლებელია.",
    err_4015: "ზონა გამორთულია, შესვლა შეუძლებელია.",
    err_4401: "ამ ანგარიშს არ აქვს ამ მაღაზიაზე წვდომის უფლება. ",
    err_4402: "ამ ანგარიშს არ აქვს ადმინისტრატორის უფლებები და ვერ იღებს დამადასტურებელ კოდს.",
    err_5001: "პაროლის დაყენება ვერ მოხერხდა, გთხოვთ, სცადოთ ხელახლა.",
  },
  verifyRefund: {
    title: "დაბრუნების მოთხოვნა",
    hint: "გთხოვთ, დაადასტუროთ დაბრუნების ინფორმაციის სისწორე დადასტურების კოდის მიწოდებამდე!",
    verifyCode: "დამადასტურებელი კოდი",
    copy: "ასლი",
    copySucceed: "კოპირება წარმატებით დასრულდა",
    copyFailed: "კოპირების წარუმატებლობა",
    expireTime: "ვადის გასვლის დრო",
    shop: "მაღაზია",
    soTime: "შეკვეთის დრო",
    soNo: "გაყიდვის წერტილის შეკვეთის ნომერი",
    amount: "დაბრუნების თანხა",
  },
}